import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { api, DOC_TYPES } from "@/lib/api";
import { DocumentPreview } from "@/components/DocumentPreview";
import { PreviewFrame } from "@/components/PreviewFrame";
import { ExportButtons, HiddenPrintable, useDocumentExport } from "@/components/DocumentExport";

export default function SharePage() {
  const { token } = useParams();
  const { data, error } = useQuery({ queryKey: ["public", token], queryFn: async () => (await api.get(`/public/documents/${token}`)).data, retry: false });
  const exp = useDocumentExport(data?.document);
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);

  if (error) return <div className="min-h-screen grid place-items-center p-8 text-center" data-testid="share-not-found"><div><h1 className="font-display text-3xl font-black mb-2">Document not found</h1><p className="text-muted-foreground">This link may have expired or the document was deleted.</p></div></div>;
  if (!data) return <div className="min-h-screen grid place-items-center overline animate-pulse">Loading</div>;
  const { document: doc, settings } = data;

  return (
    <div className="min-h-screen bg-background grain" data-testid="share-page">
      <header className="border-b border-border bg-background/70 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between gap-4">
          <div>
            <div className="overline">{settings.company_name || "DocFlow"} · {DOC_TYPES[doc.type].label}</div>
            <div className="font-mono font-semibold" data-testid="share-number">{doc.number}</div>
          </div>
          <ExportButtons exp={exp} compact />
        </div>
      </header>
      <main className="relative z-10 max-w-5xl mx-auto px-4 sm:px-8 py-8 sm:py-12">
        <div className="bg-muted p-4 sm:p-8 border border-border">
          <PreviewFrame>{(scale) => <DocumentPreview doc={doc} settings={settings} shareToken={token} scale={scale} />}</PreviewFrame>
        </div>
      </main>
      <HiddenPrintable exp={exp} doc={doc} settings={settings} shareToken={token} />
    </div>
  );
}
